// Sign in, forgot, reset, two-step, the company switch hand-off and invites. Outside the app.
import { createRoute } from "@tanstack/react-router";
import {
  ForgotPassword,
  Handoff,
  InviteAccept,
  OfficeSignIn,
  ResetPassword,
  SignIn,
  TwoStep,
} from "../../screens/auth/AuthScreens";
import { rootRoute } from "./base";

const signIn = createRoute({ getParentRoute: () => rootRoute, path: "/sign-in", component: SignIn });

// Crew sign in is /sign-in now; /sign-in/phone stays for links and home screen icons made before (owner, Oct 31).
const phoneSignIn = createRoute({ getParentRoute: () => rootRoute, path: "/sign-in/phone", component: SignIn });

const officeSignIn = createRoute({ getParentRoute: () => rootRoute, path: "/sign-in/office", component: OfficeSignIn });

const forgot = createRoute({
  getParentRoute: () => rootRoute,
  path: "/forgot",
  validateSearch: (s: Record<string, unknown>): { email?: string } =>
    typeof s.email === "string" && s.email ? { email: s.email } : {},
  component: ForgotPassword,
});

const reset = createRoute({
  getParentRoute: () => rootRoute,
  path: "/reset/$token",
  component: function ResetRoute() {
    const { token } = reset.useParams();
    return <ResetPassword token={token} />;
  },
});

const twoStep = createRoute({
  getParentRoute: () => rootRoute,
  path: "/two-step",
  validateSearch: (s: Record<string, unknown>) => ({ mode: s.mode === "setup" ? ("setup" as const) : ("needed" as const) }),
  component: TwoStep,
});

// The new tab a company switch opens at another brand's address.
const handoff = createRoute({ getParentRoute: () => rootRoute, path: "/handoff", component: Handoff });

const invite = createRoute({
  getParentRoute: () => rootRoute,
  path: "/invite/$token",
  component: function InviteRoute() {
    const { token } = invite.useParams();
    return <InviteAccept token={token} />;
  },
});

export const authRoutes = [signIn, phoneSignIn, officeSignIn, forgot, reset, twoStep, handoff, invite] as const;
